<script>
export default {
  name: 'statistics',
  props: {
    data: { required: true },
  },
};
</script>
<template>
<div class="statistics">
  <ul class="statistics-content">
    <li
      v-for="statistic in data"
      :key="statistic.label"
      class="statistic"
    >
      <span class="statistic-value">{{ statistic.value }}</span>
      <span class="statistic-label">{{ statistic.label }}</span>
    </li>
  </ul>
</div>
</template>

<style src="../styles/Statistics.scss" lang="scss" />
